import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 21C8B558-8398-43E8-A79A-8BA99BE693D6
 * name keyboard-backspace
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-backspace.svg
 * tags
 */
export const KeyboardBackspaceIcon = createSvgIcon(<><path d="M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z" /></>, 'KeyboardBackspaceIcon');
export default KeyboardBackspaceIcon